/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */

import { apiSlice } from '../Slices/apiSlice';

export const userService = apiSlice.injectEndpoints({
  
  endpoints: (builder) => ({
    getAllUser: builder.query({
      query: () => "/user-management/manage-user",
      transformResponse: (response) => {
        console.log('API Response:', response); 
        return response.data ? response.data : [];
      },
      providesTags: ["user"],
    }),

    getUserById: builder.query({
      query: (userId) => `/user-management/manage-user/${userId}`, 
      providesTags: ["user"],
    }),

    createUser: builder.mutation({
      query: (UserDetails) => ({
        url: '/user-management/manage-user',
        method: "POST",
        body: UserDetails,
      }),
      invalidatesTags: ["user"],
    }),

    updateUser: builder.mutation({
      query: (userDetails) => ({
      url: '/user-management/manage-user',
        method: "PUT",
        body: userDetails,  
      }),
      invalidatesTags: ["user"],
    }),
    
    deleteUser: builder.mutation({
      query: (userId) => ({
        url: `/user-management/delete-user/${userId}`,
        method: "POST",
      }),
      invalidatesTags: ["user"],
    }),

    getUserBr: builder.query({
      query: () => "",
    }),

    getUserDetails: builder.query({
      query: () => ({
        url: `/user-management/manage-user/getById`
      }),
      providesTags: ['image'],
      providesTags: ['user']
    }),
  }),
});

export const {
  useGetAllUserQuery,
  useGetUserByIdQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useGetUserBrQuery,
  useGetUserDetailsQuery,

} = userService;
